package pl.decks.personal.components.widgets.ranks

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier

@Composable
fun SlotRank(rank: Rank, modifier: Modifier = Modifier) = Column(
    modifier = RanksStylesheet.SlotRank.toModifier().then(modifier),
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    rank.render()
    SpanText("level ${rank.slot.ordinal + 1}", RanksStylesheet.SlotLevel.toModifier())
    SpanText(rank.title, RanksStylesheet.SlotTitle.toModifier())
}
